import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import "../CSS/Contact.css"
import { BsHeadset, BsFillPinMapFill } from 'react-icons/bs';
import { BiMailSend } from 'react-icons/bi';
import Bounce from 'react-reveal/Bounce';
import Zoom from 'react-reveal/Zoom';
import $ from "jquery";
import Footer from '../Component/Footer';

const Contact = () => {

  // email 


  const [custName, setCustName] = useState("");
  const [custContact, setCustContact] = useState("");
  const [custMessage, setCustMessage] = useState("");

  const OnSubmit = (e) => {


    if (!custName || !custContact || !custMessage) {
      alert("Please fill in all fields.");
      return;
    }


    var body = '<!DOCTYPE html><html><head><title>Whatever-Events</title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta http-equiv="X-UA-Compatible" content="IE=edge"></head><body style="margin:0!important;padding:0!important;background-color:#eee" bgcolor="#eeeeee"><div style="display:none;font-size:1px;color:#fefefe;line-height:1px;font-family:Open Sans,Helvetica,Arial,sans-serif;max-height:0;max-width:0;opacity:0;overflow:hidden"></div><table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#fff"><tr><td align="center" style="background-color:#eee" bgcolor="#eeeeee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td align="center" valign="top" style="font-size:0;padding:10px" bgcolor="#e3007a"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:6px;font-weight:800;line-height:10px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;line-height:24px;padding:10px"><a href="tel:+91 986745454" style="text-decoration:none;color:#fbab18;font-family:serif;font-size:16px">Leade Generate for Whatever Event</a></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:15px" bgcolor="#fff"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:36px;font-weight:800;line-height:48px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-weight:800"><img style="width:100%;height:120px" src="http://whateverevents.in/static/media/WHATEVER%20EVENTS%20LOGO.3b93813a09c738c0c6e8.png" alt=""></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:0" bgcolor="#e3007a"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td width="100%" align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;padding:10px 0" class="mobile-center"><h1 style="text-transform:capitalize;font-size:14px;font-weight:500;margin:0;text-align:center;color:#fbab18">Client Enquiry Details</h1></td></tr></table></div></td></tr><tr><td align="center" height="100%" valign="top" width="100%" style="padding:0 35px 35px 35px;background-color:#fff" bgcolor="#eee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:660px"><tr><td width="100%" align="center" valign="top" style="font-size:0"><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;text-align:center;width:100%"><table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#0074be">Customer Name:</p><p style="font-size:14px;font-weight:500;color:#111">' + custName + '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#0074be">Customer Contact:</p><p style="font-size:14px;font-weight:500;color:#111">' + custContact + '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#0074be">Customer Message:</p><p style="font-size:14px;font-weight:500;color:#111">' + custMessage + '</p></td></tr></table></div></td></tr></table></td></tr><tr><td width="100%" align="center" bgcolor="#e3007a" style="padding:10px 0"><p style="color:#fbab18;font-weight:500;font-size:1rem;padding:0;margin:0">© Copyright 2023 Whatever Event</p></td></tr></table></td></tr></table></body></html>';

    // console.log(custServices)

    $.post("https://skdm.in/server/v1/send_lead_mail.php", {

      toEmail: "astrovastumahip@gmail.com",
      fromEmail: "skdmlead@gmail.com",
      bccMail: "skdmlead@gmail.com",
      mailSubject: "New Customer Lead",
      mailBody: body,
      accountName: "Divineastrovastu ",
      accountLeadSource: "http://divineastrovastu.in/",
      accountLeadName: custName,
      // accountLeadEmail: custEmail,
    },

      function (dataa, status) {
        console.log('data :' + dataa);
        // console.log("name:" + custName);
        // console.log("name:" + custEmail);
        // console.log("name:" + custCheckIn);
      });

    alert("Your Form has Submitted Our team will contact with You  soon.");
    e.preventDefault()

    return false;

  }


  return (
    <>

      {/* /////////////////////// SEO ////////////////////////// */}

      <Helmet>
        <meta name='description' content='Mahip Agarwal is one of the best vastu expert in Mumbai. With more the 10 years as vastu consultant he helped lot of his clients achieve success. Call Now!' />
        <meta name="title" content="Best Vastu Expert in Mumbai | By Mahip Agarwal  Consult Now!" />
        <meta name="keywords" content="best vastu consultant,vastu consultant,vastu shastra consultant,vastu expert in mumbai,vastu consultant in mumbai,best vastu consultant in mumbai,best vastu expert in Mumbai" />
        {/* <!-- Open Graph --> */}
        <meta property="og:url" content="http://divineastrovastu.in/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Divine Astro Vastu" />

        <link rel="canonical" href="http://divineastrovastu.in/ " />
      </Helmet>

      {/* /////////////////////// SEO ////////////////////////// */}

      {/* ///////////////////////////////// section 2 ////////////////////////////////// */}

      <section className='Contact-Section-2'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-4'>
              <div className='Contact-Information'>
                <h3 className='Contact-Information-h3'>
                  <Bounce left cascade>
                    Contact Information
                  </Bounce>
                </h3>
                <a href="tel:900-492-2225" >
                  <div className='contact-info-con'>
                    <Zoom>
                      <div className='Contact-icon'>
                        <BsHeadset />
                      </div>
                    </Zoom>
                    <div className='Contact-icon-info-con'>
                      <div className='Contact-icon-info'>
                        <h3>
                          Exploration Call
                        </h3>
                        <p>
                          +91 90049 22225
                        </p>
                      </div>
                    </div>
                  </div>
                </a>

                <a href="mailto:astrovastumahip@gmail.com">
                  <div className='contact-info-con'>
                    <Zoom>
                      <div className='Contact-icon'>
                        <BiMailSend />
                      </div>
                    </Zoom>
                    <div className='Contact-icon-info-con'>
                      <div className='Contact-icon-info'>
                        <h3>
                          Email Info
                        </h3>
                        <p>
                          astrovastumahip@gmail.com
                        </p>
                      </div>
                    </div>
                  </div>
                </a>

                <a href='https://www.google.com/maps?ll=19.101316,72.843701&z=14&t=m&hl=en&gl=IN&mapclient=embed&cid=1270245891622736962' target='blank'>
                  <div className='contact-info-con'>
                    <Zoom>
                      <div className='Contact-icon'>
                        <BsFillPinMapFill />
                      </div>
                    </Zoom>
                    <div className='Contact-icon-info-con'>
                      <div className='Contact-icon-info'>
                        <h3>
                          Address
                        </h3>
                        <p>
                          Flat no 10, 3rd floor, A wing
                          Damodar bhavan,
                          Vallabhbhai patel Road,
                          Vile Parle West
                          Mumbai - 400056
                          Landmark: Shubham hall
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='Contact-Form-details'>
                <div className='Contact-form-text'>
                  <Bounce left cascade>
                    <h3>Get in touch</h3>
                  </Bounce>
                  <p>Ask me a question, I'd love to hear more from you.</p>
                </div>
                <div className='contactpage-form'>
                  <form>
                    <div className='tow-inputs'>
                      <label>
                        <input type="text" name="name" placeholder='Your Full Name' onChange={(e) => setCustName(e.target.value)} />
                      </label>
                      <label>
                        <input type="number" name="contact" placeholder='Your Contact Number' onChange={(e) => setCustContact(e.target.value)} />
                      </label>
                    </div>
                    <div className='message-input'>
                      <label>
                        <textarea type="textarea" name="Message" placeholder='Your Message' onChange={(e) => setCustMessage(e.target.value)} />
                      </label>
                    </div>
                    <div className='contact-btn'>
                      <button className='Sub-btn' onClick={OnSubmit}>
                        submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >

      <section className='ContactUs-map'>
        <div className='container'>
          <div className='Contact-iframe'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15080.577985843716!2d72.8437008!3d19.1013159!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9a5c3a8e35d%3A0x11a0d1e88b929442!2sDivine%20Astro%20Vastu!5e0!3m2!1sen!2sin!4v1680941408452!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>          </div>
        </div>
      </section>

      <Footer />

    </>
  )
}

export default Contact